export default {
  'mapView': {
    'routeTo': 'Route vers cet endroit',
    'polygonDetails': 'Détails du polygone',
    'polygon': 'Polygon',
    'whatIsHere': 'Qu\'est-ce ici ?',
    'directionsFromHere': 'Itinéraire d\'ici',
    'fitAllFeatures': 'Afficher tous les éléments',
    'addRouteStop': 'Ajouter un arrêt d\'itinéraire ici',
    'addDestinationToRoute': 'Ajouter une destination à l\'itinéraire',
    'acquirePositionErrors': {
      'generic': 'Il n\'a pas été possible d\'acquérir votre position car elle n\'était pas autorisée ou le navigateur/appareil ne la prend pas en charge.',
      'unavailable': 'Selon votre navigateur/appareil, votre emplacement n\'est actuellement pas disponible. Assurez-vous que l\'option/le service de positionnement est correctement configuré.',
      'permissionDenied': 'Votre position n\'a pas pu être acquise car le navigateur/l\'appareil en a refusé l\'accès. Vous pouvez réessayer en modifiant les paramètres du navigateur/de l\'appareil, puis en cliquant à nouveau sur le \'bouton ma position \'',
      'timeout': 'Votre navigateur/appareil a returné \'timeout\' en essayant d\'acquérir une position. Vous pouvez réessayer en cliquant sur le bouton \'ma position\''
    },
    'yourCurrentLocation': 'Votre emplacement actuel',
    'options': 'Options',
    'polylineMeasure': {
      'bearingTextIn': 'Entrée',
      'bearingTextOut': 'Sortie',
      'tooltipTextDragAndDelete': 'Cliquez et faites glisser jusqu\'au <b>point de déplacement</b><br>Appuyez sur la touche MAJ et cliquez pour <b>supprimer le point</b>',
      'tooltipTextResume': '<br>Appuyez sur la touche CTRL et cliquez pour <b>reprendre la ligne</b>',
      'tooltipTextDelete': 'Appuyez sur la touche MAJ et cliquez pour <b>supprimer le point</b>',
      'tooltipTextAdd': 'Appuyez sur la touche CTRL et cliquez pour <b>ajouter un point</b>',
      'clearControlTitle': 'Effacer les mesures',
      'measureControlTitleOn': 'Activer la mesure de distance',
      'measureControlTitleOff': 'Désactiver la mesure de distance',
      'unitControlTitle': {
        'text': 'Changer les unités',
        'metres': 'mètres',
        'landmiles': 'milles terrestres',
        'nauticalmiles': 'milles nautiques'
      },
      'clearControlLabel': '&times',
      'measureControlLabel': '&#8614;',
      'measureControlClasses': [],
      'unitControlLabel': {
        'metres': 'm',
        'kilometres': 'km',
        'feet': 'ft',
        'landmiles': 'M',
        'nauticalmiles': 'MN'
      }
    },
    'defineAvoidPolygon': 'Définir les polygones à éviter pour le calcul d\'itinéraire',
    'defineAvoidRectangle': 'Définir des rectangles à éviter pour le calcul d\'itinéraire',
    'youCantIntersectPolygons': 'Vous ne pouvez pas croiser des polygones',
    'polygonArea': 'Zone de polygone',
    'highlighting': 'Mise en évidence',
    'accuracy': 'Précision',
    'youCanCenterAtYourLocationLater': 'Vous pouvez à tout moment centrer la carte sur votre position actuelle en cliquant sur le bouton \'ma position\'',
    'yourLocation': 'Utilisez votre emplacement',
    'setMyLocationAsMapCenter': 'Voulez-vous centrer la carte à votre emplacement actuel ? Cela améliorera la précision de la recherche de lieux. Vous devrez l\'autoriser si vous y êtes demandé.',
    'removePlace': 'Supprimer le champ de lieu',
    'viewOnORS': 'Voir sur ORS',
    'moveMapPositionToLeft': 'Déplacer le centre de la carte vers la gauche',
    'moveMapPositionToRight': 'Déplacer le centre de la carte vers la droite',
    'moveMapPositionToUp': 'Déplacer le centre de la carte vers le haut',
    'moveMapPositionToDown': 'Déplacer le centre de la carte vers le bas',
    'toggleDirect': 'Basculer directement d\'ici à l\'endroit suivant',
    'heightGraph': {
      'distance': 'Distance',
      'elevation': 'Élévation',
      'segment_length': 'Longueur du segment',
      'type': 'Type',
      'legend': 'Légende'
    },
    'editShape': 'Modifier la forme',
    'remove': 'Supprimer',
    'avoidPolygonSaved': 'Éviter le polygone enregistré',
    'avoidPolygonRemoved': 'Éviter le polygone supprimé',
    'avoidPolygonNotRemoved': 'Il n\'a pas été possible de supprimer le polygone à éviter',
    'avoidPolygonNotSaved': 'Il n\'a pas été possible d\'enregistrer le polygone à éviter',
    'polygonEditModeEnabled': 'Lorsque vous avez terminé les modifications, cliquez n\'importe où pour enregistrer les modifications',
    'customTileProvider': 'Fournisseur de tuiles personnalisées défini par l\'utilisateur',
    'gestureHandling': {
      'touch': 'Utilisez deux doigts pour déplacer la carte',
      'scroll': 'Utilisez ctrl + défilement pour agrandir la carte',
      'scrollMac': 'Utilisez ⌘ + faire défiler pour agrandir la carte'
    }
  }
}
